import { Box } from '@hivebrite/design-system/Box';
import { CheckboxInput } from '@hivebrite/design-system/Inputs';
import { Pill } from '@hivebrite/design-system/Pill';

import { UserName } from './UserName';
import { type NotifyUser } from '../types';

interface FilteredUserProps {
  isDisabled?: boolean;
  isSelected?: boolean;
  onUserClick: (user: NotifyUser) => void;
  user: NotifyUser;
}

const FilteredUser = ({
  isDisabled,
  isSelected = false,
  onUserClick,
  user,
}: FilteredUserProps) => (
  <Box justifyContent="space-between" alignItems="center" mb={3}>
    <Box alignItems="center" mr={1}>
      <UserName user={user} />
      {user.isRecommended && (
        <Box ml={2} mr={1}>
          {/* @ts-expect-error Pill extends ...otherProps but style is not in the PillProps type */}
          <Pill style={{ whiteSpace: 'nowrap' }}>
            {s__('NotifyPeople|Suggested user')}
          </Pill>
        </Box>
      )}
    </Box>
    {/* Padding so that the outline is not cropped */}
    <Box paddingRight="2px">
      <CheckboxInput
        disabled={isDisabled}
        id={user.id.toString()}
        name={user.name}
        checked={isSelected}
        onChange={() => onUserClick(user)}
        data-testid="user-targeting-user"
      />
    </Box>
  </Box>
);

export default FilteredUser;
